export default {
    START_COURSE: "START_COURSE",
    START_COURSE_ERROR: "START_COURSE_ERROR",
    START_COURSE_SUCCESS: "START_COURSE_SUCCESS",
};